import { TransactionView } from "@common/types/views/transactionViews";
import { NamedView } from "@common/types/views/views";
import { DEFAULT_VIEW_ID } from "@components/views/constants";

interface ResolveTransactionsPageOpeningViewOptions {
    savedBaseViewId: string | null | undefined;
    cachedView: TransactionView | undefined;
    defaultView: NamedView<TransactionView> | undefined;
}

export interface ResolvedTransactionsPageOpeningView {
    view: TransactionView | undefined;
    baseViewIdToSave: string | undefined;
}

export function resolveTransactionsPageOpeningView({
    savedBaseViewId,
    cachedView,
    defaultView,
}: ResolveTransactionsPageOpeningViewOptions): ResolvedTransactionsPageOpeningView {
    if (savedBaseViewId !== undefined) {
        return { view: cachedView ?? defaultView, baseViewIdToSave: undefined };
    }

    // A working view cached without a selected id predates view selection;
    // it was always shown as Transactions review, whatever the default is now.
    if (cachedView) {
        return {
            view: cachedView,
            baseViewIdToSave: DEFAULT_VIEW_ID,
        };
    }

    return { view: defaultView, baseViewIdToSave: defaultView?.id };
}
